/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmEventsV1TargetState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_EVENTS_V1_TARGET_STATE_ENTITY_NAME = 'ixm.events.v1.Target';
export const ixmEventsV1TargetStateEntity = new schema.Entity<IxmEventsV1TargetState>(IXM_EVENTS_V1_TARGET_STATE_ENTITY_NAME, {}, { idAttribute: 'targetId' });

